import useDemoHelper from "./useDemoHelper";
import step71 from "../../../../../assets/demo/emergency/7.1.mp3";
import step72 from "../../../../../assets/demo/emergency/7.2.mp3";
import step73 from "../../../../../assets/demo/emergency/7.3.mp3";

window.sound = new Audio();

export default function () {
    const demoHelper = useDemoHelper();

    const completeCompletedWorks = async visual => {
        if (!visual) {
            demoHelper.flash("#completed-works", 3)
            await demoHelper.sleep(3500);
            return;
        }

        await demoHelper.type('#completed-works', "Description des travaux réalisés");
    }

    const flashUpdateQuotation = async () => {
        await demoHelper.sleep(4000);

        demoHelper.flash('[data-test="button-menu"]', 2);

        await demoHelper.sleep(2000);

        demoHelper.click('[data-test="button-menu"]');

        await demoHelper.sleep(500);

        demoHelper.flash(document.querySelector('[data-test="menu-modify-quotation"]'), 5);

        await demoHelper.sleep(5500);

        document.getElementsByClassName('MuiModal-backdrop')[0].click();
    }

    const flashCompleteReport = async () => {
        await demoHelper.sleep(4000);

        demoHelper.flash('[data-test="button-next-step"]', 3);

        await demoHelper.sleep(5000);
    }


    return {
        async launch(audio = true, visual = true) {
            demoHelper.lockInteract();

            // 6 seconds
            window.sound.src = step71;
            window.sound.play();

            await flashUpdateQuotation();
            //await completeCompletedWorks(visual);

            // 6 seconds
            window.sound.src = step72;
            window.sound.play();

            await flashCompleteReport();

            // 3 seconds
            window.sound.src = step73;
            window.sound.play();

            demoHelper.unlockInteract();
        }
    }
}